<template>
  <div v-if="isLoading" class="custom-loading">
    <div class="custom-loading-spinner">
      <FontAwesomeIcon icon="fa-solid fa-spinner" spin />
      <span>loading...</span>
    </div>
  </div>
  <!-- Header -->
  <InvoiceHeader
    :show-title="showTitle"
    :firm="currentFirm"
    :pages="pages"
    :page-sizes="pageSizes"
    :num-items="count"
    :loading="isLoading"
    @search="search"
    @add="newInvoice"
    @delete="removeInvoices"
  />
  <div class="table-responsive mt-2">
    <div class="custom-listing">
      <z-table
        v-model="records"
        class="table table-bordered table-striped"
        :is-single-row-detail="false"
        :is-header-fixed="isHeaderFixed"
        :sort-by="sortBy"
        :order-by="orderBy"
        :columns="tableColumnsName"
        :detail-column-class="detailColumnClass"
        :loading="isLoading"
        @sort="setOrder"
      >
        <template #tbody="props">
          <td class="custom-column-60">
            <a href="#" @click="viewInvoice(props.row.invoice)">view</a>
          </td>
          <td class="custom-column-200">{{ formatDate(props.row.createdOn) }}</td>
          <td class="custom-column-200">{{ props.row.ronumber }}</td>
          <td class="custom-column-200">{{ props.row.invoiceNumber }}</td>
          <td>{{ props.row.vendorName }}</td>
          <td>{{ props.row.status }}</td>
          <td scope="row" class="custom-column-120">{{ props.row.invoice }}</td>
          <td v-if="isAdmin">{{ props.row.firmName }}</td>
          <td class="custom-column-60">
            <a href="#" @click="removeInvoice(props.row.invoice)">remove</a>
          </td>
        </template>
        <template #empty> Nothing found! </template>
      </z-table>
    </div>
  </div>
  <confirm-delete
    v-model="actionDelete"
    :confirm-title="confirmDeleteTitle"
    :confirm-action="confirmDeleteAction"
    :confirm-question="confirmDeleteQuestion"
    @closing="closeModal"
    @proceed="performDeletion"
  />
  <DialogInvoice v-model="actionInvoice" :show-firm="showFirm" @closing="closeModal" @analyzed="analyzed" @saved="savedInvoice" />
</template>
<script>
import { mapState, mapActions } from 'pinia'
import { authStore } from '@/stores/auth'
import { lookupStore } from '@/stores/lookup'
import { invoiceStore } from '@/stores/invoice'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import globals from '@/plugins/globals'
import ZTable from '@/components/utilities/elements/Table.vue'
import InvoiceHeader from './InvoiceHeader.vue'
import ConfirmDelete from '@/components/utilities/elements/ConfirmDialog.vue'
import DialogInvoice from '@/components/invoice/forms/DialogInvoice.vue'
export default {
  name: 'InvoiceList',
  components: {
    FontAwesomeIcon,
    ZTable,
    InvoiceHeader,
    ConfirmDelete,
    DialogInvoice
  },
  data() {
    return {
      actionInvoice: null,
      actionDelete: null,
      confirmDeleteTitle: 'Confirm Invoice Deletion',
      confirmDeleteAction: 'Delete',
      confirmDeleteQuestion: 'Are you sure you wish to Permanently Delete this invoice?',
      isHeaderFixed: true,
      page: 1,
      pageSizes: [
        { name: '10', value: 10 },
        { name: '25', value: 25 },
        { name: '50', value: 50 },
        { name: '100', value: 100 }
      ],
      detailColumnClass: 'custom-column-60',
      firm: null,
      showFirm: false,
      isAdd: false,
      deleteId: null
    }
  },
  async mounted() {
    this.page = 1
    this.isAdd = false
    this.setListParam({
      name: 'page',
      value: this.page
    })
    this.resetInvoice(this.currentFirm.firm)
    await this.getLookups({
      keys: ['Status'],
      firm: 1,
      refresh: true
    })
    await this.search()
  },
  computed: {
    ...mapState(authStore, ['profile']),
    ...mapState(invoiceStore, ['loading', 'listParams', 'invoices', 'isChecked', 'firm']),
    isAdmin() {
      let _is = false
      if ([1].includes(this.profile.roles[0])) {
        _is = true
      }
      return _is
    },
    currentFirm() {
      let _firm = null
      if (this.firm == null) {
        _firm = {
          firm: this.profile.firm,
          firmName: this.profile.firmName
        }
        return _firm
      } else {
        return this.firm
      }
    },
    count() {
      return this.invoices.count
    },
    records() {
      return this.invoices.items
    },
    tableColumnsName() {
      let columns = [
        {
          field: 'invoice',
          label: '',
          sortable: false,
          class: 'custom-column-60'
        },
        { field: 'createdOn', label: 'Date', sortable: true, class: 'custom-column-200' },
        { field: 'ronumber', label: 'RO #', sortable: true, class: 'custom-column-200' },
        { field: 'invoiceNumber', label: 'Invoice #', sortable: true, class: 'custom-column-200' },
        { field: 'vendorName', label: 'Vendor', sortable: true },
        { field: 'status', label: 'Status', sortable: true },
        {
          field: 'invoice',
          label: 'Id',
          sortable: true,
          class: 'custom-column-120'
        }
      ]
      if (this.isAdmin) {
        columns.push({
          field: 'firmName',
          label: 'Location',
          sortable: true
        })
      }
      columns.push({
        field: 'invoice',
        label: '',
        sortable: false,
        class: 'custom-column-60'
      })
      return columns
    },
    pages() {
      return Math.ceil(this.invoices.count / this.listParams.pageSize)
    },
    sortBy() {
      return this.listParams.sortBy
    },
    orderBy() {
      return this.listParams.orderBy
    },
    isLoading() {
      let _is = false
      if (this.loading.invoices) {
        _is = true
      }
      return _is
    }
  },
  methods: {
    ...mapActions(lookupStore, ['getLookups']),
    ...mapActions(invoiceStore, [
      'setListParam',
      'paginate',
      'getInvoice',
      'getInvoices',
      'resetCells',
      'resetInvoice',
      'deleteInvoice',
      'deleteInvoices'
    ]),
    formatDate(date, type = 'datetime') {
      return globals.formatDate(date, type)
    },
    closeModal() {
      this.actionInvoice = null
      this.actionDelete = null
    },
    async setOrder(column, sortBy) {
      this.page = 1
      this.setListParam({
        name: 'sortBy',
        value: sortBy
      })
      this.setListParam({
        name: 'orderBy',
        value: column.field
      })
      await this.search(this.page, this.searchTerm)
    },
    analyzed() {
      this.search()
    },
    showInactive(isInactive) {
      let _data = null
      if (isInactive) {
        _data = 'Y'
      }
      return _data
    },
    async search(page = 1) {
      // Load up the records
      try {
        this.page = page
        console.log('Getting Invoices', this.listParams)
        await this.getInvoices({
          page: this.page,
          offset: (this.page - 1) * this.listParams.pageSize,
          sortBy: this.listParams.sortBy,
          orderBy: this.listParams.orderBy,
          pageSize: this.listParams.pageSize,
          searchTerm: this.listParams.searchTerm,
          firm: this.firm !== undefined && this.firm !== null ? this.firm.firm : this.profile.firm,
          status: null,
          filter: this.listParams.filterBy !== null ? this.listParams.filterBy.toString() : null
        })
      } catch (e) {
        console.log('Error', e)
      }
    },
    async viewInvoice(id) {
      console.log('view invoice', id)
      this.resetCells()
      this.resetInvoice(this.currentFirm.firm)
      await this.getInvoice(id)
      this.actionInvoice = true
    },
    newInvoice() {
      this.resetCells()
      this.resetInvoice(this.currentFirm.firm)
      this.isAdd = true
      this.actionInvoice = {
        isAdd: true,
        invoice: null,
        firm: null
      }
    },
    savedInvoice() {
      this.isAdd = false
      this.search()
    },
    async removeInvoice(id) {
      this.deleteId = id
      // console.log('remove invoice', id)
      this.actionDelete = true
    },
    removeInvoices() {
      this.deleteId = null
      if (this.isChecked) {
        this.actionDelete = true
      }
    },
    async performDeletion() {
      if (this.deleteId !== null) {
        await this.deleteInvoice(this.deleteId)
        this.actionDelete = null
        await this.search()
      } else {
        let invoices = []
        for (let invoice of this.invoices.items) {
          if (invoice.isChecked) {
            invoices.push({
              invoiceId: invoice.invoice.toString(),
              token: null
            })
          }
        }
        this.actionDelete = null
        if (invoices.length > 0) {
          this.page = 1
          await this.deleteInvoices(invoices)
          this.actionDelete = false
          await this.search()
        }
      }
    }
  }
}
</script>
<style lang="scss">
.custom-listing {
  overflow-x: hidden;
  overflow-y: auto;
  width: 100%;
  max-height: 70vh;
  height: 70vh;
}
.custom-loading {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 999999;
  background: rgba(0, 0, 0, 0.3);
  .custom-loading-spinner {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    text-align: center;
    font-weight: 700;
    padding: 10px;
    z-index: 12;
    background-color: white;
    height: 45px;
    width: 150px;
    border-radius: 5px;
    span {
      margin-left: 5px;
      background-color: #fff;
    }
  }
}
</style>
